export const setStorage = (itemKey,itemData) => {
  if(itemKey&&itemData){
    localStorage.setItem(itemKey,typeof itemData === 'object'?JSON.stringify(itemData):itemData)
  }else{
    console.error('setStorage 参数不全')
  }
}

export const getStorage = (itemKey) => {
  try{
      return JSON.parse(localStorage.getItem(itemKey))
  }catch(e){

      return localStorage.getItem(itemKey)
  }
}
export const clearStorage =()=>{
  localStorage.clear()
}
